// BuyerModal.jsx
import React from 'react';
import { BiWorld } from "react-icons/bi";
import { LiaShippingFastSolid } from "react-icons/lia";
import { BsPeopleFill } from "react-icons/bs";
import { IoPricetags } from "react-icons/io5";
import { MdOutlineShoppingCart } from "react-icons/md";
import { HiOutlineCalendarDateRange } from "react-icons/hi2";
import { MdPayment } from "react-icons/md";
import { MdOutlineDescription } from "react-icons/md";

const BuyerModal = ({ buyer, onClose }) => {
  if (!buyer) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-5 ">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl p-6">
        <div className="flex justify-between items-start">
          <h2 className="text-xl font-semibold">Buyer From India</h2>
          <button onClick={onClose} className="text-xl text-gray-500 hover:text-red-600">&times;</button>
        </div>

        {/* Details Grid - 3 columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mt-6 text-sm text-gray-800">
          <div className="flex items-center space-x-2">
            <span className="text-2xl text-gray-500"><BiWorld /></span>
            <span className=''><strong>Destination :</strong> India</span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-xl text-gray-500"><IoPricetags /></span>
            <span><strong>Target price :</strong> Negotiable</span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-xl text-gray-500"><MdPayment /></span>
            <span><strong>Payment terms :</strong> Bank transfer</span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-xl text-gray-500"><BsPeopleFill /></span>
            <span><strong>Looking for supplier from :</strong> India</span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-xl text-gray-500"><MdOutlineShoppingCart /></span>
            <span><strong>Quantity Required :</strong> 500 tons</span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-xl text-gray-500"><HiOutlineCalendarDateRange /></span>
            <span><strong>Date :</strong> Sep 20, 2024</span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-xl text-gray-500"><LiaShippingFastSolid /></span>
            <span><strong>Shipping terms :</strong> CIF</span>
          </div>
        </div>

        {/* Product Description */}
        <div className="mt-6">
          <h3 className="text-sm font-semibold mb-2 flex"><span><  MdOutlineDescription className='text-lg text-gray-500' /></span>Product Description :</h3>
          <div className="border rounded p-4 bg-gray-50 text-gray-700 text-sm h-28 overflow-y-auto">
            We are seeking quotations from reputable suppliers for the procurement of high-quality fresh fruits.
            Our goal is to ensure a consistent supply of fresh produce to meet our business needs and customer demands.
            We are seeking quotations from reputable suppliers for the procurement of high-quality fresh fruits.
            Our goal is to ensure a consistent supply of fresh produce to meet our business needs and customer demands.
          </div>
        </div>

        {/* Button */}
        <div className="mt-6 text-right">
          <button
            className="px-6 py-2 bg-sky-600 text-white font-medium rounded hover:bg-sky-700 transition"
            onClick={onClose}
          >
            Enquire now
          </button>
        </div>
      </div>
    </div>

  );
};

export default BuyerModal;
